// JavaScript Document
(function (doc, win) {
    var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
  
      recalc = function () {
        var clientWidth = docEl.clientWidth; //获取设备尺寸
        var shejiWidth = 0;//设计图的标准尺寸
        if (clientWidth >= 1200) {
          shejiWidth = 1920
        } else if (clientWidth >= 768 && clientWidth < 1200) {
          shejiWidth = 768
        } else if (clientWidth < 768) {
          shejiWidth = 375
        }
        docEl.style.fontSize = 100 * (clientWidth / shejiWidth) + 'px';
      };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false); //绑定事件
    doc.addEventListener('DOMContentLoaded', recalc, false);
  
  })(document, window);
  
  
  


// WEBPACK FOOTER //
// ./src/assets/js/rem.js